module.exports = __webpack_public_path__ + "static/6i-f3d4de8d0afb19e777c79032ce828e3d.woff";